import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  loading: false
};

export default function user(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.user;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        break;
      }
      case '@organization/UPDATE_SUCCESS': {
        draft.profile.organization = action.payload.organization;
        break;
      }
      case '@user/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@user/UPDATE_SUCCESS': {
        draft.loading = false;
        draft.profile = action.payload.profile;
        break;
      }
      case '@user/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@user/UPDATE_PASSWORD_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@user/UPDATE_PASSWORD_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@user/UPDATE_PASSWORD_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@user/UPDATE_ROLE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@user/UPDATE_ROLE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@user/UPDATE_ROLE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}